import { type AddToFavoritesProperties, ampli as ampliDigital } from '@src/ampli-web-digital'
import { configPublic } from '@src/config.public'
import { omitNullish } from '@src/utils/object.util'

import { type AnalyticsContentType, getAnalyticsContentType } from './analytics-helpers.util'

const APP_NAME = configPublic.general.appName

export const FAVORITES_SCREEN_NAME = 'all favorites'

type FavoriteContentType = AddToFavoritesProperties['favorite content type']

function toFavoriteContentType(
  type: AnalyticsContentType | undefined
): FavoriteContentType | undefined {
  switch (type) {
    case 'program':
    case 'block':
    case 'compilation':
    case 'workout':
    case 'lesson':
    case 'recipe':
      return type
    default:
      return undefined
  }
}

export type FavoriteArgs = {
  slug: string
  title: string
  type?: CocoApi.EntityType | CocoApi.ContentType
  parentSlug?: string
  screenName?: string
  tabName?: string
}

function getFavoriteEventProps(args: FavoriteArgs) {
  const favoriteContentType = toFavoriteContentType(getAnalyticsContentType(args.type))
  if (!favoriteContentType) return null

  return omitNullish({
    'app name': APP_NAME,
    'favorite item slug': args.slug,
    'favorite item title': args.title,
    'favorite content type': favoriteContentType,
    'favorite parent slug': args.parentSlug,
    'screen name': args.screenName,
    'tab name': args.tabName,
  })
}

export function trackAddToFavorites(args: FavoriteArgs) {
  if (!ampliDigital.isLoaded) return
  const props = getFavoriteEventProps(args)
  if (!props) return
  ampliDigital.addToFavorites(props)
}

export function trackRemoveFromFavorites(args: FavoriteArgs) {
  if (!ampliDigital.isLoaded) return
  const props = getFavoriteEventProps(args)
  if (!props) return
  ampliDigital.removeFromFavorites(props)
}

export function trackSelectFromFavorites(args: FavoriteArgs) {
  if (!ampliDigital.isLoaded) return
  const props = getFavoriteEventProps(args)
  if (!props) return
  ampliDigital.selectFromFavorites(props)
}
